import SituacionAprendizajeForm from './situaciones_aprendizaje/SituacionAprendizajeForm.vue';

export default {
  install: (app, _options) => {
    app.component('LomloeSituacionAprendizajeForm', SituacionAprendizajeForm);
  },
};
